import { AppActions } from 'app/app-actions.enum';
import { CollectionAction } from '../collection-action.interface';
import { CollectionActions } from '../collection-actions.enum';
import { CollectionState } from '../collection-state.interface';
import onCreateSuccess from './on-create-success';
import onDeleteSuccess from './on-delete-success';
import onStateSuccess from './on-state-success';
import onUpdateListSuccess from './on-update-list-success';
import onUpdateSuccess from './on-update-success';

const onSuccess = (
  state: CollectionState,
  action: CollectionAction,
): CollectionState => {
  switch (action.type) {
    case CollectionActions.SET_AS_DEFAULT:
      return {
        ...state,
        defaultCollectionId: action.collectionId,
      };

    case AppActions.LOAD_STATE_SUCCESS:
      return onStateSuccess(state, action);

    case CollectionActions.UPDATE_LIST_SUCCESS:
      return onUpdateListSuccess(state, action);

    case CollectionActions.DELETE_SUCCESS:
      return onDeleteSuccess(state, action);

    case CollectionActions.CREATE_SUCCESS:
      return onCreateSuccess(state, action);

    case CollectionActions.ADD_ASSETS_SUCCESS:
    case CollectionActions.REMOVE_ASSETS_SUCCESS:
    case CollectionActions.CHANGE_NAME_SUCCESS:
    case CollectionActions.UPDATE_SUCCESS:
    default:
      return onUpdateSuccess(state, action);
  }
};

export default onSuccess;
